<template>
  <div class="toolbar">
      <el-tooltip class="item" effect="dark" content="显示或关闭物联网设备实时信息框" placement="top-start">
          <div :class="{'active':buttonState0}"  @click="togglePop()">物联</div>
      </el-tooltip>  
      <el-tooltip class="item" effect="dark" content="显示或隐藏二维影像地图" placement="top">
          <div :class="{'active':buttonState1}"  @click="toChangeMap2()">二维</div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="显示或隐藏三维场景地图" placement="top">
          <div :class="{'active':buttonState2}"  @click="toChangeMap3()">三维</div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="模拟观察者在原地360度转圈查看周围场景" placement="top">
          <div :class="{'active':buttonState3}"  @click="toRotate()">自转</div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="模拟观察者围绕屏幕中心点360度转圈" placement="top">
          <div :class="{'active':buttonState4}"  @click="toCircleFly()">盘旋</div>
			</el-tooltip>
      <el-tooltip class="item" effect="dark" content="回到站点的初始观察点" placement="top">
          <div @click="toViewPoint()">视角</div>
      </el-tooltip>
      <div @click="toConfig()" v-if="false">配置</div>
  </div>
</template>

<script>
import $ from 'jquery';
import * as  Cesium from  'cesium/Cesium';

export default {
  name: 'toolBar',
  components:{},
  props:{
    viewer:{
      type:Object,
      defalut:function(){
        return {}
      }
    },
    father:{
      type:Object,
      defalut:function(){
        return {}
      }
    }
  },
  data(){
    return {
      //viewer:{},
      activeindex: -1,
      buttonState0: true,
      buttonState1: false,
      buttonState2: false,
      buttonState3: false,
      buttonState4: false,

      sceneType: '二维',
      intervalPoint: null
    }
  },

  methods:{
    togglePop(){
        if(this.buttonState0){
            $('.cls-div-tip').hide();
            this.buttonState0 = false;
        }else{
            $('.cls-div-tip').show();
            this.buttonState0 = true;
        }
    },

    toChangeMap2(){
        this.buttonState2 = false;
        if(this.buttonState1){
            this.buttonState1 = false;
        }else{
            this.buttonState1 = true;
        }
        this.father.changeMap2(this.buttonState1);
    },

    toChangeMap3(){
        this.buttonState1 = false;
        if(this.buttonState2){
            this.buttonState2 = false;
        }else{
            this.buttonState2 = true;
        }
        this.father.changeMap3(this.buttonState2);
    },

    //二三维切换
    // toChangeSceneType(){
    //   this.activeindex = 1;
    //   this.father.changeScene();
    //   if(this.father.myPrimitive){
    //     this.sceneType = '二维';
    //   }else{
    //     this.sceneType = '三维';
    //   }
    // },

    //自转
    toRotate(){
      this.buttonState4 = false;
      if(this.intervalPoint){
          clearInterval(this.intervalPoint);
          this.intervalPoint = null;
      }
      if(this.buttonState3){
          this.buttonState3 = false;
      }else{
          this.intervalPoint = setInterval(this.rotate,50);
          this.buttonState3 = true;
      }

      // this.activeindex = 2;
      // if(this.intervalPoint){
      //   clearInterval(this.intervalPoint);
      //   this.intervalPoint = null;
      // }else{
      //   this.intervalPoint = setInterval(this.rotate,50);
      // } 
    },

    rotate(){
      var heading = this.viewer.camera.heading + 0.001;
      // var heading = Cesium.Math.toDegrees(this.viewer.camera.heading);
      // if(heading>=360 || heading<=-360) heading = 0;
      // heading = heading + 0.05;//调节转动快慢 0.25
      var pitch = this.viewer.camera.pitch;
      this.viewer.scene.camera.setView({
          orientation: {
              heading : heading, //Cesium.Math.toRadians(heading),
              pitch : pitch
          }
      });

    },

    toCircleFly(){
      console.log('----begin toCircleFly----')
      this.buttonState3 = false;
      if(this.intervalPoint){
          clearInterval(this.intervalPoint);
          this.intervalPoint = null;
      }
      if(this.buttonState4){
          this.buttonState4 = false;
      }else{
          this.intervalPoint = setInterval(this.circleFly,50);
          this.buttonState4 = true;
      }

      // this.activeindex = 3;
      // if(this.intervalPoint){
      //   clearInterval(this.intervalPoint);
      //   this.intervalPoint = null;
      // }else{
      //   var me = this;
      //   try{
      //     this.intervalPoint = setInterval(me.circleFly,50);
      //   }catch(e){
      //     console.log('----e----', e);
      //     clearInterval(this.intervalPoint);
      //     this.intervalPoint = null;
      //   }
        
      // } 
    },

    circleFly(){
          var heading = this.viewer.camera.heading - 0.001;//0.001
          var pitch =  this.viewer.camera.pitch; 
          var _pStart = this.getCenterPosition();
          var _pEnd = this.viewer.camera.position;
          var distance = this.computeDistance(_pStart, _pEnd);
          this.viewer.scene.camera.setView({
            destination :_pStart,
            orientation:{
                heading: heading,
                pitch : pitch,

            }
          });
          this.viewer.scene.camera.moveBackward(distance);
    },
		toViewPoint(){
      console.log('----');
      // this.activeindex = 4;
      this.father.flyTo(this.father.dataRequest);
    },

    //跳转到配置三维页面
    toConfig(){
      this.$router.push({
        name: "configScene",
      });
    },

    computeDistance(pStart, pEnd){
      var point1cartographic = Cesium.Cartographic.fromCartesian(pStart);
      var point2cartographic = Cesium.Cartographic.fromCartesian(pEnd);
			var geodesic = new Cesium.EllipsoidGeodesic();
			geodesic.setEndPoints(point1cartographic, point2cartographic);
      var distance = geodesic.surfaceDistance;
		    //返回两点之间的距离
      distance = Math.sqrt(Math.pow(distance, 2) + Math.pow(point2cartographic.height - point1cartographic.height, 2));	
			return distance;
    }, 

    getCenterPosition() {
      return this.viewer.camera.pickEllipsoid(new Cesium.Cartesian2(this.viewer.canvas.clientWidth/2, this.viewer.canvas.clientHeight/2));
    }

  },
  created(){
  },
  mounted(){}
}
</script>
<style lang="scss" scoped>
.active{color: white !important;background-color: #e8552b !important;}
.toolbar{position: absolute;left: 30px;bottom: 30px}
.toolbar div{position: relative; float: left;
    background: #303336;
    opacity: 0.8;
    border: 1px solid #eee;
    color: #edffff;
    fill: #edffff;
/*    border-radius: 4px;*/
    padding: 5px 12px;
/*    margin: 2px 3px;*/
    cursor: pointer;
    overflow: hidden;
    width:40px;
    height:30px;
    line-height: 30px;
/*    box-shadow: rgb(124, 177, 124) 0px 0px 2px 2px ;*/
    }
</style>